import React, { useCallback } from "react"
import styled from "styled-components"
import { navigate } from "gatsby"
import { useLocation } from "@reach/router"

const Link = styled.p`
  cursor: pointer;
`

type Props = {
  page: string
  section?: string
  children: React.ReactNode
  clickCallback?: () => void
}

const ScrollLink: React.FC<Props> = ({
  page,
  section,
  clickCallback,
  ...props
}: Props) => {
  const { pathname } = useLocation()

  const navigateToSection = useCallback(() => {
    if (section) {
      const sectionElement = document.getElementById(section)
      if (sectionElement) {
        window.scrollTo({ top: sectionElement.offsetTop, behavior: "smooth" })
        window.scrollTo({ top: sectionElement.offsetTop, behavior: "smooth" })
      }
    }
  }, [section])

  const handleClick = useCallback(() => {
    if (pathname === page) {
      navigateToSection()
    } else {
      navigate(page)
      window.setTimeout(() => {
        navigateToSection()
      }, 200)
    }
    if (clickCallback) {
      clickCallback()
    }
  }, [pathname, page, navigateToSection, clickCallback])

  return <Link onClick={handleClick} {...props}></Link>
}

export default ScrollLink
